import styled from 'styled-components';

import { CARD_OPENING_TRANSITION_DURATION } from '#@/shared/constants';
import { mediaQueries, mixins } from '#@/shared/utils/styles';
import { zIndexValues } from '#@/shared/utils/styles/zIndexValues';

export const DROPDOWN_CARD_EDGE_OFFSET = 10;

export interface CardProps {
  $isOpen: boolean;
  $fixedWidth?: number;
  $maxWidth?: number;
  $zIndex?: number;
}

const Card = styled.div<CardProps>`
  position: fixed;
  pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
  z-index: ${(props) => props.$zIndex ?? zIndexValues.overlayElement};

  width: ${(props) => (props.$fixedWidth ? `${props.$fixedWidth}px` : 'max-content')};
  max-width: ${(props) => (props.$maxWidth ? `${props.$maxWidth}px` : '90vw')};

  background: #fff;
  border-radius: 8px;
  max-height: 100%;
  overflow-y: auto;

  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  transition: opacity ${CARD_OPENING_TRANSITION_DURATION}ms cubic-bezier(0.83, 0, 0.17, 1);
  ${mixins.boxShadowMedium2022()};

  @media ${mediaQueries.mobile} {
    width: 300px;
    max-height: 80%;
  }

  @media ${mediaQueries.tablet} {
    max-height: 100%;
  }
`;

export default Card;
